export enum TIME_FORMAT {
    HOUR_12 = 'h:mm a'
}
